export class FocusHelper {
  static footer;

  static setFooter(footer) {
    FocusHelper.footer = footer;
  }

  static setOnFocus(element) {
    element.addEventListener("focus", () => {
      FocusHelper.onFocusAction(element);
    });
  }

  static onFocusAction(element) {
    if (FocusHelper.footer) {
      let footerBound = FocusHelper.footer.getBoundingClientRect();
      let elementBound = element.getBoundingClientRect();
      if (footerBound.top <= elementBound.bottom) {
        window.scrollBy(0, elementBound.bottom - footerBound.top + 10);
      }
    }
  }
}
